import { useState } from 'react'
import { useSendExpertiseMessageMutation } from '@/core/graphql/hooks'
import { ExpertiseStatus } from '@/core/graphql/types'
import { Expertise } from '../lib/expertise-detail.types'

export function useExpertiseChat(expertise: Expertise) {
  const [newMessage, setNewMessage] = useState('')

  const [sendMessageMutation, { loading: isSending }] = useSendExpertiseMessageMutation({
    onCompleted: () => setNewMessage(''),
    refetchQueries: ['getMyInfos'],
    onError: (error) => console.error('Error sending message:', error),
  })

  const sendMessage = async () => {
    if (!expertise._id || !newMessage.trim()) return
    try {
      await sendMessageMutation({ variables: { payload: { expertiseId: expertise._id, message: newMessage.trim() } } })
    } catch (error) {
      // Error is surfaced through the mutation's onError callback
    }
  }

  return {
    messages: expertise.chatRoom?.messages ?? [],
    currentUserId: expertise.patient?._id,
    canSendMessage: expertise.status !== ExpertiseStatus.Closed,
    newMessage,
    setNewMessage,
    isSending,
    sendMessage,
  }
}
